// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"78":"87fe07d6","338":"27b1b901","453":"99a35fbd","541":"cc0befc0","544":"cfeea098","576":"ffee91b5","753":"b35760dd","775":"2482adbb","823":"fc0c77f3","990":"09bf03d1"}[chunkId] + ".js";
};